import { useFormContext } from 'react-hook-form';

import InputForm from 'shared/components/Input/InputForm';
import { GENERAL_INFO_TITLE, SETTINGS_TITLE } from 'shared/containers/ViewDetails/ViewDetails';

function SCHCTemplatesManageDataMainSection() {
  const {
    register,
    getValues,
    control,
    formState: {
      errors,
    },
  } = useFormContext();

  return (
    <div className="scroll">
      <div className="form__section">
        <h3>{ GENERAL_INFO_TITLE }</h3>
        <InputForm.TextField
          fullWidth
          sx={{ mt: 1, mb: 1 }}
          label="Name"
          register={register('name')}
          errorField={errors.name}
        />
        <InputForm.TextField
          fullWidth
          sx={{ mt: 1, mb: 1 }}
          label="SCHC Template ID"
          register={register('sCHCTemplateID')}
          errorField={errors.sCHCTemplateID}
        />
        <InputForm.TextField
          fullWidth
          sx={{ mt: 1, mb: 1 }}
          label="Description"
          register={register('description')}
          errorField={errors.description}
        />
      </div>
      <div className="form__section">
        <h3>{ SETTINGS_TITLE }</h3>
        <InputForm.Checkbox
          label="LoRaWAN (Payload with Rule ID)"
          defaultChecked={getValues().unruly}
          name="unruly"
          control={control}
          helpText="Supports rule ID as part of the payload"
        />
        <InputForm.Checkbox
          label="Legacy"
          defaultChecked={getValues().legacy}
          name="legacy"
          control={control}
          helpText="Adds support for non-schc devices sending raw data"
        />
      </div>
    </div>
  );
}

export default SCHCTemplatesManageDataMainSection;
